(() => {
  if (window.__latestNewsCarouselInit) return;
  window.__latestNewsCarouselInit = true;

  const setNavActive = (section, index) => {
    const target = String(index + 1);
    const navs = section.querySelectorAll('.js-latest-news-nav-item');
    navs.forEach((el) => {
      const a = el.getAttribute('data-index');
      el.classList.toggle('active', a === target);
    });
  };

  const initializeLatestNewsCarousel = () => {
    document.querySelectorAll('.js-latest-news-carousel').forEach((el) => {
      if (el._splide) return;

      el.classList.add('active');

      const root = el.classList.contains('splide')
        ? el
        : el.querySelector('.splide') || el;

      const section = el.closest('.shopify-section') || document;

      const splide = new Splide(root, {
        type: 'slide',
        rewind: true,
        gap: '100px',
        arrowPath:
          "M12.744 18.9481C12.5878 19.1044 12.5 19.3163 12.5 19.5373C12.5 19.7582 12.5878 19.9702 12.744 20.1264L17.4582 24.8406C17.6153 24.9924 17.8258 25.0764 18.0443 25.0745C18.2628 25.0726 18.4718 24.9849 18.6263 24.8304C18.7808 24.6759 18.8685 24.4669 18.8704 24.2484C18.8723 24.0299 18.7883 23.8194 18.6365 23.6623L15.3448 20.3706H26.3807C26.6017 20.3706 26.8136 20.2828 26.9699 20.1265C27.1262 19.9702 27.214 19.7583 27.214 19.5373C27.214 19.3162 27.1262 19.1043 26.9699 18.948C26.8136 18.7917 26.6017 18.7039 26.3807 18.7039H15.3448L18.6365 15.4123C18.7883 15.2551 18.8723 15.0446 18.8704 14.8261C18.8685 14.6076 18.7808 14.3986 18.6263 14.2441C18.4718 14.0896 18.2628 14.0019 18.0443 14.0001C17.8258 13.9981 17.6153 14.0821 17.4582 14.2339L12.744 18.9481Z",
      });

      splide.on('mounted', () => setNavActive(section, splide.index));
      splide.on('move',    (newIndex) => setNavActive(section, newIndex));
      splide.on('updated refresh', () => setNavActive(section, splide.index));

      splide.mount();

      el._splide = splide;
    });
  };

  document.addEventListener('click', (e) => {
    const nav = e.target.closest('.js-latest-news-nav-item');
    if (!nav) return;

    const raw = nav.getAttribute('data-index') ?? nav.getAttribute('data-idnx');
    if (!raw) return;

    const index = Math.max(0, parseInt(raw, 10) - 1);
    const section = nav.closest('.shopify-section') || document;
    const carousel = section.querySelector('.js-latest-news-carousel');
    const splide = carousel?._splide;
    if (!splide) return;

    e.preventDefault();

    setNavActive(section, index);
    splide.go(index);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const blockId = event.detail.blockId;

    let block =
      (blockId && document.querySelector('[data-block-id="' + blockId + '"]')) ||
      (blockId && document.getElementById('shopify-block-' + blockId)) ||
      (blockId && document.getElementById(blockId)) ||
      detail.el;

    if (!block) return;

    const slide = block.closest('.splide__slide');
    const section = block.closest('.shopify-section') || document;

    let carousel = slide
      ? slide.closest('.js-latest-news-carousel')
      : section.querySelector('.js-latest-news-carousel');

    if (!carousel || !carousel._splide) return;

    const splide = carousel._splide;

    if (slide) {
      const slides = Array.from(carousel.querySelectorAll('.splide__slide'));
      const index = slides.indexOf(slide);
      if (index !== -1) {
        setNavActive(section, index);
        splide.go(index);
      }
    }

    const scrollTarget =
      carousel.classList.contains('splide')
        ? carousel
        : carousel.querySelector('.splide') || carousel;

    if (scrollTarget && scrollTarget.scrollIntoView) {
      scrollTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  });

  document.addEventListener('DOMContentLoaded', initializeLatestNewsCarousel);
  document.addEventListener('shopify:section:load', initializeLatestNewsCarousel);
  document.addEventListener('shopify:section:reorder', initializeLatestNewsCarousel);
  document.addEventListener('shopify:section:select', initializeLatestNewsCarousel);
  document.addEventListener('shopify:block:deselect', initializeLatestNewsCarousel);
})();